import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import system from "./system";
Vue.use(Vuex);
import persistedState from "vuex-persistedstate";
export default new Vuex.Store({
  state: {
    treeList: [],
    fgList: [],
    user:'',
  },
  mutations: {
    getTreeList(state, data) {
      state.treeList = data;
    },
    getFgList(state, data) {
      state.fgList = data;
    },
    setUser(state,data){
      state.user = data
    }
  },
  actions: {},
  modules: {
    system,
  },
  getters,
  plugins: [persistedState({})],
});
